import React, { FunctionComponent, useEffect, useMemo } from 'react';
import { useStore } from 'effector-react';
import SpamFilters from '@components/SpamFilters';
import SpamCommentsList from '@components/SpamCommentsList';
import SpamPageLayout from '@components/SpamPageLayout';
import useSpamFilters from '@hooks/useSpamFilters';
import localeWeightStore, { resetLocaleWeight, DEFAULT_LOCALE_WEIGHT } from '@stores/localeWeight';
import { reset as resetSpamComments } from '@stores/spamComments';

interface CommentsSpamRouteProps {}

const CommentsSpamRoute: FunctionComponent<CommentsSpamRouteProps> = () => {
  const { spam, getById, getList } = useSpamFilters();
  const { filters } = useStore(spam);
  const locale = useStore(localeWeightStore);

  useEffect(() => {
    const { id } = filters;

    if (id) {
      getById(id);
    } else {
      getList();
    }

    return () => {
      resetSpamComments();
      resetLocaleWeight();
    };
  }, []);

  const hasActiveFilters = useMemo(() => {
    return Boolean(
      filters.id || filters.author || filters.needChecked || locale !== DEFAULT_LOCALE_WEIGHT,
    );
  }, [filters, locale]);

  return (
    <SpamPageLayout
      filters={<SpamFilters />}
      hasActiveFilters={hasActiveFilters}
    >
      <SpamCommentsList />
    </SpamPageLayout>
  );
};

export default CommentsSpamRoute;
